import { toast } from '@dd3tech/wiggui/Toast'
import { defaultApiBasicX } from '@wiggot/apis'
import { useModalCreateListStore } from '../../../store/modals/modal-create-list.store'
import { IResponseService } from '../../../../interfaces/src/generals.interface'

interface ICreateListResponse {
  statusCode: number
  message: string
  data: {
    createdAt: string
    updatedAt: string
    id: string
    name: string
    publicId: string
    status: 'ACTIVE' | 'DELETE'
    userId: number
  }
}

export const createList = async ({
  name
}: {
  name: string
}): Promise<IResponseService<any>> => {
  try {
    const response = await defaultApiBasicX.post<
      ICreateListResponse,
      {
        list: {
          name: string
        }
      }
    >(`/properties-lists/lists`, {
      list: {
        name
      }
    })

    return {
      isSuccess: true,
      data: response.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const editList = async ({
  id,
  newName
}: {
  id: string
  newName: string
}): Promise<IResponseService<any>> => {
  try {
    const response = await defaultApiBasicX.put<
      ICreateListResponse,
      {
        name: string
      }
    >(`/properties-lists/lists/${id}`, {
      name: newName
    })

    return {
      isSuccess: true,
      data: response.data
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const useModalCreateList = () => {
  const {
    nameNewList,
    listIdToEdit,
    setListCreated,
    setListIdToEdit,
    setNameNewList,
    setIsOpen,
    setIsLoading
  } = useModalCreateListStore()

  const createNewList = async () => {
    try {
      setIsLoading(true)
      const { isSuccess, data } = await createList({
        name: nameNewList
      })

      if (isSuccess) {
        setNameNewList('')
        setIsOpen(false)
        setListCreated({
          success: true,
          id: data?.id,
          name: data?.name
        })
        return
      }

      toast({
        type: 'error',
        title: 'Ocurrio un error al crear la lista'
      })
    } catch {
      toast({
        type: 'error',
        title: 'Ocurrio un error al crear la lista'
      })
    } finally {
      setIsLoading(false)
    }
  }

  const editListName = async () => {
    if (!listIdToEdit) {
      return
    }

    try {
      setIsLoading(true)
      const { isSuccess } = await editList({
        id: listIdToEdit,
        newName: nameNewList
      })

      if (isSuccess) {
        setNameNewList('')
        setIsOpen(false)
        setListCreated({ success: true })
        setListIdToEdit('')
        return
      }

      toast({
        type: 'error',
        title: 'Ocurrio un error al editar la lista'
      })
    } catch {
      toast({
        type: 'error',
        title: 'Ocurrio un error al editar la lista'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    createNewList,
    editListName
  }
}
